<template>
  <modal-v2 relaxed-header :show="show" :on-close="closeModal">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header-v2
        :header-title="$t('D_ASSISTANCE.SETTINGS.TITLE')"
        :header-content="$t('D_ASSISTANCE.SETTINGS.MODAL_DESC')"
      />
      <digital99-assistance-setting @cancel="closeModal" />
    </div>
  </modal-v2>
</template>

<script>
import Digital99AssistanceSetting from 'dashboard/components/widgets/digital99Assistance/Digital99AssistanceSetting.vue';

export default {
  name: 'GptSettingsModal',
  components: { Digital99AssistanceSetting },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
